<template>
  <div class="carbox_container">
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <div style="padding-top:50px;">
      <van-list v-if="cartslist.length != 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <!-- 名片列表 -->
        <div class="indexes" style="background-color:#f8f8f8;">
          <div class="cu-list menu-avatar no-padding">
            <div v-for="(cell,index) in cartslist" :key="index">
              <div class="cu-item item-bottomline" :data-id="cell.suid" @click="linktoMessage">
                <!-- 默认头像判断 -->
                <div v-if="cell.avatar_url" class="cu-avatar round lg" :style="'background-image:url('+cell.avatar_url+');'"></div>
                <div v-else class="cu-avatar round lg" :style="'background-image:url('+guideIconSlider+');'"></div>
                <div>
                  <div class="text-grey texts-messages">
                    <span class="texts-names">{{cell.name}}</span>
                  </div>
                  <div class="text-gray text-sm texts-company">{{cell.company_name}} <span v-if="cell.job_title">|</span> {{cell.job_title}}</div>
                </div>
                <div class="circle-cell-fllow">
                  <button v-if="cell.status == 0" @click.stop="favorclick" :data-id="cell.suid">同意</button>
                  <button v-else class="active" @click.stop="">已同意</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>

      <div class="nofollowbox" v-else>
        <div class="nofollowpic">
          <img :src="nofollowpicIcon" />
        </div>
        <div class="nosearchtext">暂无交换申请</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getcartLlist, getFriendRequest, friendPass } from "../../api/api";
import navbar from "../public/navbar.vue";
import Vue from "vue";
import { Toast } from "vant";

// 全局注册
Vue.use(Toast);
export default {
  name: "exchangecart",
  components: { navbar },
  data () {
    return {
      titlename: "交换申请",
      cartslist: [],
      page: 0,
      pageCount: 0,
      nofollowpicIcon: require("../../assets/images/circle_icon_wu.png"),
      guideIconSlider: require("../../assets/images/guide_icon_slider.png"),
      loading: false,
      finished: false,
    };
  },
  created () {
    Toast.loading({
      mask: true,
      message: '加载中...'
    });
    this.initCartList();
  },
  activated () {
    this.initCartList();
  },
  methods: {
    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        this.loading = false;
        if (page >= pageCount) {
          this.loading = false;
          this.finished = true;
          return;
        }
        this.page = page;
        let json = {
          page: page
        };
        getFriendRequest(json).then(res => {
          if (res.data.code == 200) {
            let mytjcirclearr = that.cartslist;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              mytjcirclearr.push(e);
            });
          }
        });
      }, 500);
    },
    //获取名片列表
    initCartList () {
      let json = {
        page: 0,
      };
      getFriendRequest(json).then(res => {
        Toast.clear();
        if (res.data.code == 200) {
          this.pageCount = res.data.data.pageCount;
          this.cartslist = res.data.data.list;
          this.finished = false;
        }
      }).catch(err => {
        Toast.clear();
      });
    },
    //跳转到名片
    linktoMessage: function (e) {
      this.$router.push({
        path: '/othercart',
        query: {
          id: e.currentTarget.dataset.id
        }
      })
    },
    //通过好友
    favorclick: function (e) {
      let that = this;
      let id = e.currentTarget.dataset.id;
      for (var i = 0; i < that.cartslist.length; i++) {
        if (that.cartslist[i].suid == id) {
          //遍历找到对应的id
          friendPass(id).then(res => {
            if (res.code == 200) {
              that.cartslist[i].status = 1
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.navbar {
  position: relative;
  z-index: 99;
}
.carbox_container {
  height: 100%;
  background-color: #f8f8f8;
}
.item-bottomline {
  border-bottom: 0.02702702702702703rem solid #f8f8f8;
}
.item-bottomline:last-of-type {
  border: none;
}
.texts-messages {
  font-size: 0.6486486486486487rem;
}
.texts-names {
  color: #000;
  margin-right: 0.6486486486486487rem;
  font-weight: bold;
  font-family: "SimHei";
  font-size: 0.8108108108108109rem;
  margin-bottom: 0.35135135135135137rem;
}
.texts-job {
  font-size: 0.7027027027027027rem;
  color: #666;
}
.texts-company {
  width: 10.81081081081081rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.7027027027027027rem;
  color: #999;
  margin-top: 0.2702702702702703rem;
}
.indexes {
  position: relative;
}
.nofollowbox {
  padding-top: 2.7027027027027026rem;
  text-align: center;
}
.nofollowbox .nofollowpic {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
  margin: 0 auto;
}
.nofollowbox .nofollowpic img {
  width: 7.837837837837838rem;
  height: 6.243243243243243rem;
}
.nofollowbox .nosearchtext {
  text-align: center;
  padding-top: 1.3513513513513513rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}
.cu-list.menu-avatar .cu-item {
  position: relative;
  display: flex;
  padding-right: 0.2702702702702703rem;
  height: 3.7837837837837838rem;
  background-color: white;
  justify-content: flex-end;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
}
.cu-avatar.lg {
  width: 2.5945945945945947rem;
  height: 2.5945945945945947rem;
  font-size: 2em;
  border-radius: 50%;
  margin-right: 0.6486486486486487rem;
  background-size: 100%;
}

.circle-cell-fllow {
  display: flex;
  margin: 0 0.6rem 0 1rem;
}
.circle-cell-fllow button {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3.2432432432432434rem;
  height: 1.35rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
}
.circle-cell-fllow button.active {
  background: #fff;
  border: 1px solid #ffbd0a;
  color: #ffbd0a;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/exchangecart.vue